import { Component, Inject, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ValueFormatter, DomainOptions } from '../../../../../../../../../../../common/components/data-table/formatters/data-table.formatters';
import { AbstractControl } from '@angular/forms';
import { DATA_TOKEN } from '../../../../grid-option-config/tokens';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { LunaDomain } from '../../../../../../../../../../models/domain.model';
import { DomainDefinitionService } from '../../../../../../../../../../services/domain-definition.service';
import { filter, map } from 'rxjs/operators';

const StringIsNotANumber = value => isNaN(Number(value)) === true;

@Component({
    selector: 'domain-options',
    templateUrl: './domain-options.component.html',
    standalone: false
})

export class DomainOptionsComponent implements OnInit, AfterViewInit, OnDestroy {

    formControl: AbstractControl;
    types = ValueFormatter;
    public domains: Observable<LunaDomain[]>;
    public domainProperties: Observable<Array<string>>;
    isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private subscriptions = new Subscription();
    options: DomainOptions = {
        domain: "",
        idProperty: "Code",
        displayProperty: "Definition",
        domainValues: {}
    };


    constructor(
        @Inject(DATA_TOKEN) public data: AbstractControl,
        public _domainService: DomainDefinitionService
    ) {
        this.domains = this._domainService.getAll();

        this.formControl = this.data;

        if (this.formControl.value) {
            this.options = this.formControl.value;
        }


        this.updateSelectedDomainValues()
    }

    ngOnInit() {

        this.isLoading$.next(true);
        this.subscriptions.add(this.domains.subscribe(
            data => { },
            error => { },
            () => { this.isLoading$.next(false); }));

        this.fetchDomainValues();
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
    }

    public fetchDomainValues(): void {
        this.domainProperties = this._domainService.get(this.options.domain).pipe(
            filter(x => Array.isArray(x.values)),
            map(x => this.getPropertiesForDomain(x)));
    }

    public getPropertiesForDomain(domain: LunaDomain): Array<string> {

        if (!domain)
            return undefined;

        let key = domain.values[Object.keys(domain.values)[0]];

        return Object.keys(key);
    }

    updateSelectedDomainValues() {

        this.formControl.setValue(this.options);
    }
}

